/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';
//
const selectDomain = (state) => state['feature/visual'] || initialState;
/**
 * Getting loader state to visual component
 */
export const selectLoader = createSelector([selectDomain], (visualState) => visualState.loading);
/**
 * Getting visuals state to visual component
 */
export const selectVisuals = createSelector([selectDomain], (visualState) => visualState.visuals);
/**
 * Getting reports state to visual component
 */
export const selectReports = createSelector([selectDomain], (visualState) => visualState.reports);
/**
 * Getting reports drop down list state to visual component
 */
export const selectReportsDropdownList = createSelector([selectDomain], (visualState) =>
  visualState?.reports?.map((data) => ({ label: data.name, id: data.id }))
);
/**
 * Getting reports drop down list state to visual component
 */
export const selectReportPagesDropdownList = createSelector([selectDomain], (visualState) =>
  visualState?.reportPages?.map((data) => ({ label: data.displayName, id: data.name }))
);
/**
 * Getting the visual details by visual id state into visual component
 */
export const selectVisualByID = createSelector(
  [selectDomain],
  (visualState) => visualState.visualById
);
/**
 * Getting is session timed out state for the component
 */
export const selectIsSessionTimedOut = createSelector(
  [selectDomain],
  (visualState) => visualState.isSessionTimedOut
);
